import { Dispatch } from "redux";
import { patchPaymentsFailure, patchPaymentsRequest, patchPaymentsSuccess } from "src/store/actions/payments";
import { ActionType } from "src/store/dataService/actions/utils/actionCreator";
import { patchTo } from "./shared/osfetch";
import { findRoute } from "./util";

const patchPayment = async (
    next: Dispatch,
    { payload: { uuid, vin, payments } }: ActionType<typeof patchPaymentsRequest>
) => {
    const response = await patchTo(`/deals/${uuid}/vehicles/${vin}/payment`, { sync: true, ...payments }, next);

    if (response.ok && response.status === 200) {
        next(patchPaymentsSuccess(vin, await response.json()));
        return;
    }

    next(patchPaymentsFailure(vin));
};

const routes = {
    [patchPaymentsRequest.type]: patchPayment,
};

export default (next: Dispatch, action: any) => findRoute(routes)(next, action);
